import { ArrowBackIosNew, ArrowForwardIos } from '@mui/icons-material';
import { IconButton, Paper } from '@mui/material';
import Box from '@mui/material/Box';
import { grey } from '@mui/material/colors';
import makeStyles from '@mui/styles/makeStyles';
import Bowser from 'bowser';
import { orderBy } from 'lodash';
import Carousel from 'react-multi-carousel';
import { homeStyles } from '..';
import { PromoTileData, PromoTileSectionData } from '../../../types';
import { PromoItem } from './promo-item';

const detectMobile = (): boolean => {
  const parser = Bowser.getParser(window.navigator.userAgent);
  return parser.getPlatform().type === 'mobile';
};

const useStyles = makeStyles({
  carouselContainer: {
    paddingRight: 25,
    paddingLeft: 25,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
  carouselItem: {
    margin: 'auto',
  },
  carouselButtons: {
    borderRadius: 50,
    backgroundColor: grey[900],
    display: 'flex',
    justifyContent: 'center',
    opacity: 0.7,
    '&:hover': {
      backgroundColor: grey[900],
      opacity: 1,
    },
  },
});

export function PromoCarousel(props: {
  section: PromoTileSectionData | undefined;
  promos: PromoTileData[] | undefined;
}) {
  // Props
  const { section, promos } = props;
  // Hooks
  const classes = useStyles();
  const isMobile = detectMobile();
  // State

  const responsive = {
    desktop: {
      breakpoint: { max: 6000, min: 1024 },
      items: section?.MaxItems || 3,
      partialVisibilityGutter: 30,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      partialVisibilityGutter: 30,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      partialVisibilityGutter: 30,
    },
  };

  // @ts-ignore
  const ButtonGroup = ({ next, previous }) => {
    return (
      <Box
        className="custom-button-group"
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          position: 'absolute',
          top: '50%',
          bottom: '50%',
          px: 2,
        }}
      >
        <IconButton
          color="secondary"
          className={classes.carouselButtons}
          onClick={() => previous()}
        >
          <ArrowBackIosNew />
        </IconButton>
        <IconButton
          color="secondary"
          className={classes.carouselButtons}
          onClick={() => next()}
        >
          <ArrowForwardIos />
        </IconButton>
      </Box>
    );
  };

  if (section?.Published && promos && promos?.length > 0) {
    return (
      <Paper
        sx={{
          ...homeStyles.section,
          position: 'relative',
        }}
      >
        <Box
          py={3}
          sx={{
            ...homeStyles.title,
          }}
        >
          {section?.Section.toUpperCase()}
        </Box>
        <Box
          className="carousel-wrapper"
          maxWidth="lg"
          width="100%"
          sx={{
            position: 'relative',
            ml: 'auto',
            mr: 'auto',
            mb: 3,
          }}
        >
          <Carousel
            className={classes.carouselContainer}
            responsive={responsive}
            transitionDuration={500}
            infinite
            autoPlay
            partialVisible
            renderButtonGroupOutside={true}
            // @ts-ignore
            customButtonGroup={!isMobile ? <ButtonGroup /> : null}
            arrows={false}
            itemClass={classes.carouselItem}
          >
            {orderBy(promos, 'OrderIndex', 'asc').map((item) => {
              return <PromoItem key={item.PTId} promo={item} />;
            })}
          </Carousel>
        </Box>
      </Paper>
    );
  } else {
    return null;
  }
}
